import {
  __async,
  __spreadValues
} from "./chunk-WNQUEZJF.mjs";

// src/events/impression-event/fire-youversion-impression-event.ts
import { fireEvent } from "@youversion/analytics-core";
function fireYouVersionImpressionEvent(params, options) {
  return __async(this, null, function* () {
    const impressionEvent = __spreadValues({
      _type: "v2.ImpressionEvent"
    }, params);
    fireEvent(impressionEvent, options);
  });
}

export {
  fireYouVersionImpressionEvent
};
